import type { I18n } from "vue-i18n";

export type UpdatePageTitleTo = { path: string; meta: { title?: string } };

/**
 * function to update page title based on route path
 */
export function updatePageTitle(to: UpdatePageTitleTo, i18n: I18n): void {
  const path = to.path;

  // Skip title update for /go routes - handled by rails
  if (path.startsWith("/go")) {
    return;
  }

  const t = (key: string): string => {
    try {
      // Type assertion to bypass complex union type issues
      const translator = i18n.global.t as (key: string) => string;
      const result = translator(key);

      // Check if result is actually a translation (not the same as the key)
      if (result && result !== key) {
        return result;
      }
    } catch (_error) {
      // Silently handle i18n errors
    }

    console.error(`i18n error: could not translate key '${key}'`);
    return key;
  };

  function getFinalTitle(baseTitle: string, prefixKey?: string): string {
    let finalTitle = baseTitle;

    if (prefixKey) {
      const prefix = t(prefixKey);
      if (prefix) {
        finalTitle = `${prefix} | ${baseTitle}`;
      }
    }
    return finalTitle;
  }

  // Get base title, with fallback if translation is not available
  const baseTitle = t("tools_meta.title");
  const prefixKey = to.meta.title;
  const finalTitle = getFinalTitle(baseTitle, prefixKey);

  document.title = finalTitle;
  updateMetaTags(finalTitle);
}

function updateMetaTags(title: string): void {
  // Update og:title
  const ogTitle = document.querySelector('meta[property="og:title"]');
  if (ogTitle) {
    ogTitle.setAttribute("content", title);
  }
}
